import React from 'react';
import PropTypes from 'prop-types';
import TextArea from '@narvar/nth-text-area';
import s from '../exchangeSidebar.module.css';
import SidebarSectionTitle from '../../../react-components/SidebarSectionTitle/SidebarSectionTitle';

const ExchangeComment = ({
  title,
  isCommentBoxCountDisabled,
  exchangeComment,
  maxCommentLength,
  commentPlaceholder,
  onChange,
}) => {
  const maxLengthClassName =
    exchangeComment.length === maxCommentLength
      ? `${s.sidebar_comments_max_length} sidebar-comments-max-length`
      : '';

  return (
    <div data-test="exchange-comment">
      <SidebarSectionTitle index={2} title={title} />
      {!isCommentBoxCountDisabled && (
        <p className={`${s.sidebar_comments_length} sidebar-comments-length ${maxLengthClassName}`}>
          {exchangeComment.length}/{maxCommentLength}
        </p>
      )}
      <TextArea
        id="exchangeComment"
        className={`sidebar-comments ${s.sidebar_comments} ${
          exchangeComment ? 'filled-input' : ''
        }`}
        style={{ width: '100%' }}
        name="exchangeComment"
        label={commentPlaceholder}
        labelStyle={{ top: '0.875rem', left: '0.875rem' }}
        onChange={onChange}
        value={exchangeComment}
        tabIndex="0"
        aria-label="Comment Box"
        maxLength={maxCommentLength}
      />
    </div>
  );
};

ExchangeComment.defaultProps = {
  title: '',
  isCommentBoxCountDisabled: false,
  exchangeComment: '',
  maxCommentLength: '',
  commentPlaceholder: '',
};

ExchangeComment.propTypes = {
  title: PropTypes.string,
  isCommentBoxCountDisabled: PropTypes.bool,
  exchangeComment: PropTypes.string,
  maxCommentLength: PropTypes.number,
  commentPlaceholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default ExchangeComment;
